import { BrowserModule }          from '@angular/platform-browser';
import { NgModule }               from '@angular/core';
import { RouterModule }           from '@angular/router';
import { BrowserAnimationsModule }from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpHandler} from '@angular/common/http';

import { routes }                 from './app.routes';
import { AppComponent }           from './app.component';
import { MainLayoutModule }       from './shared';
import { LoginLayoutModule }      from './login';
import { LoginModule }            from './login';
import { PageNotFoundComponent }  from './routing';
import { AuthGuard }              from './services/auth-guard';
import {SharedCommonModule} from './shared/common';
import { TokenInterceptor }       from './services/auth';

// View Modules
import { DashboardModule }        from './dashboard/dashboard.module';
import { ClientsModule }          from './clients/clients.module';
import { OrdersModule }           from './orders/orders.module';

// UI Modules
import { GridModule }             from '@progress/kendo-angular-grid';
import { DropDownsModule }        from '@progress/kendo-angular-dropdowns';
import { ChartsModule }           from '@progress/kendo-angular-charts';
import { ApiService }             from './services/api';
import {
  LoadingIndicatorService
} from './shared/layout/components/loading-indicator';
import {FlexLayoutModule} from '@angular/flex-layout';
import {OrderDetailModule} from './orders/detail/order-detail.module';
import {BreadcrumbModule} from './shared/layout/components/breadcrumb';
import {AgmCoreModule} from '@agm/core';
import {AccountDetailModule} from './accounts/detail/account-detail.module';
import {AccountsModule} from './accounts/accounts.module';
import {AdministratorGuard} from './services/administrator-guard';
import {ConfirmDialogComponent} from './shared/layout/components/confirm-dialog/confirm-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import {ClientDetailModule} from './clients/components/client-detail.module';
import {GeocoderService} from './services/geocoder';
import {UsersModule} from './accounts/detail/components/users/users.module';
import {LocationsModule} from './accounts/detail/components/locations/locations.module';
import {UploadAssetComponent} from './orders/detail/components/upload/upload.component';
import {ShippingComponent} from './orders/detail/components/shipping/shipping.component';
import {ReactiveFormsModule} from '@angular/forms';
import {UploadModule} from '@progress/kendo-angular-upload';
import {JwtModule} from "@auth0/angular-jwt";
import {LocationSummaryService} from './services/location-summary-service';
import {ShopModule} from './shop/shop.module';
import {DistributorDashboardModule} from './distributor/dashboard/distributor-dashboard.module';
import {DistributorAccountsModule} from './distributor/distributor-accounts.module';
import {DistributorGuard} from './services/distributor-guard';
import {DistributorLocationsModule} from './distributor/distributor-locations.module';
import {DistributorOrdersModule} from './distributor/distributor-orders.module';
import {WaiversModule} from './accounts/detail/components/waivers/waivers.module';
import {AppointmentModule} from './appointments/appointment.module';
import {AccountDialogComponent} from './accounts/detail/components/account-dialog/account-dialog.component';
import {ClientDialogComponent} from './accounts/detail/components/client-dialog/client-dialog.component';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {InputsModule} from '@progress/kendo-angular-inputs';
import {NoteDialogComponent} from './clients/components/note-dialog.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {DateInputComponent, DateInputsModule} from '@progress/kendo-angular-dateinputs';
import {ShopifyService} from './services/shopify/shopify.service';
import {ExerciseService} from './services/exercise/exercise.service';
import {PublicationsModule} from './accounts/detail/components/publication/publications.module';
import {ExportsModule} from './accounts/detail/components/export/exports.module';
import {TelehealthModule} from './telehealth/telehealth.module';
import {LiveSessionModule} from './live/live-session.module';
import {DeferredSessionModule} from './live/deferred-session.module';
import {PrescriptionDialogComponent} from './live/components/prescription-dialog.component';
import {ImageViewerDialogComponent} from './live/components/image-viewer-dialog.component';
import {FileViewerDialogComponent} from './live/components/file-viewer-dialog.component';
import {AppointmentDialogComponent} from './appointments/appointment-dialog.component';
import {MDLinkService} from './services/mdlink/mdlink.service';
import {AwsSignatureService} from './services/auth/aws-signature.service';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {ProfileModule} from './profile/profile.module';
import {ImportModule} from './accounts/detail/components/import/import.module';
import {FloatingLabelModule} from '@progress/kendo-angular-label';
import {RegisterModule} from './register/register.module';
import {AssetService} from './services/assets/assets.service';
import {CommissionsModule} from './commissions/commissions.module';
import {VariantModule} from './products/variant.module';
import {ConnectResultModule} from './profile/connect-result.module';
import {BankAccountModule} from './bank/bank-account.module';
import {PaymentSourceModule} from './source/payment-source.module';
import {CurateModule} from './curate/curate.module';
import {TooltipModule} from '@progress/kendo-angular-tooltip';
import {ManagerGuard} from './services/manager-guard/manager-guard.service';
import {ManagingDistributorGuard} from './services/distributor-guard/managing-distributor-guard.service';
import {BrandService} from './services/brand-service/brand.service';
import {AppointmentService} from './services/appointment/appointment.service';
import {TranscriptionService} from './services/api/transcription.service';


@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    ConfirmDialogComponent,
    ShippingComponent,
    UploadAssetComponent,
    AccountDialogComponent,
    ClientDialogComponent,
    NoteDialogComponent,
    AppointmentDialogComponent,
    FileViewerDialogComponent,
    ImageViewerDialogComponent,
    PrescriptionDialogComponent

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    SharedCommonModule,
    DashboardModule,
    RegisterModule,
    ButtonsModule,
    InputsModule,
    VariantModule,
    FloatingLabelModule,
    TooltipModule,
    DialogModule,
    ConnectResultModule,
    ImportModule,
    BankAccountModule,
    CurateModule,
    PaymentSourceModule,
    ProfileModule,
    UploadModule,
    FlexLayoutModule,
    MainLayoutModule,
    MatExpansionModule,
    DateInputsModule,
    LoginLayoutModule,
    LoginModule,
    ClientsModule,
    ClientDetailModule,
    UsersModule,
    LocationsModule,
    WaiversModule,
    PublicationsModule,
    ExportsModule,
    TelehealthModule,
    LiveSessionModule,
    DeferredSessionModule,
    CommissionsModule,
    ShopModule,
    OrdersModule,
    OrderDetailModule,
    DistributorDashboardModule,
    DistributorAccountsModule,
    DistributorLocationsModule,
    DistributorOrdersModule,
    AccountsModule,
    AccountDetailModule,
    AppointmentModule,
    GridModule,
    ChartsModule,
    MatDialogModule,
    MatButtonModule,
    DropDownsModule,
    HttpClientModule,
    BreadcrumbModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD3OnF-PVU0Dm2dhlWgiALUEe7L2nXaddY'
    }),
    RouterModule.forRoot(routes, { useHash: true }),
    JwtModule.forRoot({
      config: {
        tokenGetter: function tokenGetter() {
          return localStorage.getItem('access_token');
        },
        // whitelistedDomains: ['localhost:3001'],
        // blacklistedRoutes: ['localhost:3001/auth/']
      }
    })
  ],
  exports: [
    RouterModule,
    DropDownsModule
  ],
  providers: [
    AuthGuard,
    AdministratorGuard,
    DistributorGuard,
    ManagerGuard,
    ManagingDistributorGuard,
    AwsSignatureService,
    MDLinkService,
    AssetService,
    AppointmentService,
    TranscriptionService,
    BrandService,
    // authProvider,
    ApiService,
    ShopifyService,
    ExerciseService,
    LocationSummaryService,
    GeocoderService,
    LoadingIndicatorService,
    HttpClient,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
